<template>
    <div>
        <form-wizard
            ref="formWizard"
            :step-size="stepSize"
            color="#D6E13A"
            @on-change="handleChange"
            @on-complete="sendOrder">
            <tab-content title="Abo">
                <order ref="orderStep" />
            </tab-content>
            <tab-content title="Adresse">
                <Address ref="addressForm" />
            </tab-content>
            <tab-content title="Übersicht">
                <OrderSummary v-if="subscriptionType"/>
            </tab-content>
            <template v-slot:footer="slotProps">
                <div v-if="slotProps.activeTabIndex === 0" class="order-result bt-0">
                    <div class="order-result-block-2 m-0">
                        <div class="order-result-block-2__col order-result-block-2__col-1">
                            <div class="order-cost-summary">
                                <div class="order-cost-summary__label">
                                    Preis
                                </div>
                                <div class="order-cost-summary__price-container">
                                    <div class="order-cost-summary__price-total">
                                        Total pro {{ mode === 'private' ? 'Lieferung' : 'Woche' }}: <br> {{ (mode === 'private' ? total('subscription') : totalPerWeek('subscription')) | round | formatPrice }}
                                    </div>
                                    <div v-show="mode === 'business'" class="order-cost-summary__price-details">
                                        Total pro Mitarbeiter / Woche: {{ totalPerPersonPerWeek('subscription') | round | formatPrice }}
                                    </div>
                                    <div class="order-cost-summary__price-details">
                                        (inkl. Lieferung / exkl. MwSt. 2.6 %)
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="order-result-block-2__col order-result-block-2__col-2 inverted-colors">
                            <a
                                href=""
                                class="order-result-block-2__link-next"
                                @click.prevent="nextTab(slotProps)"
                                @keyup.enter="nextTab(slotProps)"
                            >
                                <span class="order-result-block-2__link-next-text">
                                    Weiter zur Adresse
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
                <div v-if="slotProps.activeTabIndex === 1" class="order-address-form__btn-container">
                    <a
                        href=""
                        class="order-address-form__link--before m-0"
                        @click.prevent="prevTabAddress(slotProps.prevTab)"
                        @keyup.enter="prevTabAddress(slotProps.prevTab)"
                    >
                        Zurück zum Abo
                    </a>
                    <div
                        class="order-address-form__link--next m-0"
                        @click="nextTabAddress(slotProps.nextTab)"
                        @keyup.enter="nextTabAddress(slotProps.nextTab)"
                    >
                        Weiter zur Übersicht
                    </div>
                </div>
                <div
                    v-if="slotProps.activeTabIndex === 2"
                    class="order-summary__btn-container">
                    <a
                        href=""
                        class="order-address-form__link--before m-0"
                        @click.prevent="prevTab(slotProps)"
                        @keyup.enter="prevTab(slotProps)"
                    >
                        Zurück zur Adresse
                    </a>
                    <a
                        href=""
                        class="order-address-form__link--next m-0"
                        @click.prevent="nextTab(slotProps)"
                        @keyup.enter="nextTab(slotProps)"
                    >
                        Abo bestellen
                    </a>
                </div>
            </template>
        </form-wizard>
    </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import { mapState, mapGetters } from 'vuex';
import $ from 'jquery'; // eslint-disable-line
import moment from 'moment';

import priceMixin from '../mixins/priceMixin';
import filters from '../mixins/filters';
import Order from './Order.vue';
import Address from './Checkout/Address.vue';
import OrderSummary from './Checkout/OrderSummary.vue';

export default {
    components: {
        FormWizard,
        TabContent,
        Order,
        Address,
        OrderSummary,
    },
    mixins: [
        priceMixin,
        filters,
    ],
    data() {
        return {
            windowSize: window.innerWidth,
            stepSize: 'md',
        };
    },
    computed: {
        ...mapState({
            baskets: state => state.baskets,
            appetite: state => state.appetite,
            people: state => state.people,
            orderableSubscriptionTypes: state => state.orderable.product_groups,
            earlyInvoice: state => state.earlyInvoice,
            earlyDeliveryFee: state => state.orderable.earlyDeliveryFee,
            intervals: state => state.intervals,
            orderableIntervals: state => state.orderable.intervals,
            mode: state => state.mode,
            privateDeliveryDay: state => state.privateDeliveryDay,
            deliveryFee: state => state.orderable.deliveryFee,
        }),
        ...mapGetters([
            'amounts',
            'appetites',
            'orderableBaskets',
            'groupedBaskets',
            'allBaskets',
            'sortedBasketsMonday',
            'sortedBbasketsWednesday',
            'subscriptionType',
            'basketExtra',
            'groupedBasketsExtra',
        ]),
    },
    mounted() {
        this.getStepSize();
        window.addEventListener('resize', () => {
            this.windowSize = window.innerWidth;
            this.getStepSize();
        });
        moment.updateLocale('de', {
            months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
            monthsShort: ['Jan', 'Feb', 'März', 'Apr', 'Mai', 'Juni', 'Juli', 'Aug', 'Sept', 'Okt', 'Nov', 'Dez'],
            monthsParseExact: true,
            weekdays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
            weekdaysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
        });
    },
    methods: {
        getStepSize() {
            this.stepSize = this.windowSize <= 480 ? 'xs' : 'md';
        },
        setAddress() {
            const addressForm = this.$refs.addressForm.$refs.addressForm;
            const { invoiceAddress } = addressForm.$refs.invoiceAddress.form;
            const { deliveryAddress } = addressForm.$refs.deliveryAddress.form;

            this.$store.dispatch('updateOrder', {
                invoiceAddress,
                deliveryAddress,
                attentionBy: addressForm.$refs.deliveryAddress.form.attention_by,
                comment: addressForm.$refs.deliveryAddress.form.comment,
            });
        },
        nextTabAddress(next) {
            const $error = $('.order-address-form__required-hint');

            const addressForm = this.$refs.addressForm.$refs.addressForm;
            // check for errors and empty, required fields
            addressForm.$refs.invoiceAddress.$v.$touch();
            addressForm.$refs.deliveryAddress.$v.$touch();

            // if there are errors, jump to make them visible to the user
            if (addressForm.$refs.deliveryAddress.$v.form.$invalid ||
                addressForm.$refs.deliveryAddress.$v.form.$error ||
                addressForm.$refs.invoiceAddress.$v.form.$invalid ||
                addressForm.$refs.invoiceAddress.$v.form.$error
            ) {
                $error.show();
            } else {
                $error.hide();
                this.setAddress();
                next();
            }
            this.scrollToTop();
        },
        prevTabAddress(prev) {
            const addressForm = this.$refs.addressForm.$refs.addressForm;
            const { invoiceAddress } = addressForm.$refs.invoiceAddress.form;
            const { deliveryAddress } = addressForm.$refs.deliveryAddress.form;
            // prepare order, save addresses
            this.$store.dispatch('prepareOrder', {
                invoiceAddress,
                deliveryAddress,
                attentionBy: addressForm.$refs.invoiceAddress.form.attention_by,
                comment: addressForm.$refs.invoiceAddress.form.comment,
            });
            prev();
            this.scrollToTop();
        },
        sendOrder() {
            this.$store.dispatch('showLoadingModal', {
                message: this.mode === 'business' ? 'Ihr Korb wird zusammengestellt' : 'Dein Korb wird zusammengestellt',
            });
            this.$store.dispatch('prepareOrder');
            this.$store.dispatch('sendOrder').then(
                () => {
                    this.$store.dispatch('hideLoadingModal');
                    this.$router.push('/confirmation');
                },
                () => {
                    this.$store.dispatch('hideLoadingModal');
                    this.$router.push('/error');
                },
            );
        },
        handleChange(prev, next) {
            const addressForm = this.$refs.addressForm.$refs.addressForm;
            $('.delivery-selectpicker').selectpicker('refresh');
            this.$refs.formWizard.setValidationError(false);
            if (prev === 1 && next === 0) {
                if (addressForm.$refs.deliveryAddress.$v.form.$invalid ||
                    addressForm.$refs.deliveryAddress.$v.form.$error ||
                    addressForm.$refs.invoiceAddress.$v.form.$invalid ||
                    addressForm.$refs.invoiceAddress.$v.form.$error
                ) {
                    this.$refs.formWizard.setValidationError(true);
                }
            }
        },
        nextTab(slotProps) {
            if (slotProps.activeTabIndex === 0 && !this.$refs.orderStep.validatePostalCode()) {
                this.scrollToTop();
                return;
            }
            slotProps.nextTab();
            this.scrollToTop();
        },
        prevTab(slotProps) {
            slotProps.prevTab();
            this.scrollToTop();
        },
        scrollToTop() {
            const orderPlugin = document.getElementById('order-plugin');
            const bodyRect = document.body.getBoundingClientRect();
            const bounderies = orderPlugin.getBoundingClientRect();
            const offset = bounderies.top - bodyRect.top - 84;
            window.scrollTo({
                top: offset,
                behavior: "smooth"
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// Wizard.vue?0125ea39